import { BaseComponent } from '@eastsideco/salvo-ts';
import { cart } from './Cart';

export abstract class ThemeComponent extends BaseComponent {
}
